import React from 'react';
import {cabinMessageGroupFormFields, cabinMessageGroupListFields} from "../../network/mockData";
import BasicResource from "../cmsbase/BasicResource";

function Groups(props) {
    return (
        <BasicResource
            dataUrl="cabinmessage/groups"
            addNewButton={true}
            tableFields={cabinMessageGroupListFields}
            entityUrl="cabinmessage/groups"
            formFields={cabinMessageGroupFormFields}
            allowDelete={true}
            submitUrl="cabinmessage/groups"
            includeIdInUrlOnUpdate={true}
        />

    );
}

export default Groups;